module.exports = __webpack_public_path__ + "static/img/hb_22-min.bbddf06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_22-min.png
// module id = 9lzc
// module chunks = 1